// extracted by mini-css-extract-plugin
module.exports = {"send":"Send_send__mnO7Z","file":"Send_file__2NkRg","smile":"Send_smile__2Kkqd","form":"Send_form__31ALC","input":"Send_input__1p4TU","button":"Send_button__2Cm41"};